package com.eladfinish.bible.contest.common.gender

import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.provider.JsStringProvider

actual class GenderPersonalizedStringDesc actual constructor(
    private val original: StringDesc,
    private val hebrewGender: HebrewGender,
) : StringDesc {

    override suspend fun toLocalizedString(): String {
        val resolvedString = original.toLocalizedString()
        return resolvedString.personalizeGender(hebrewGender)
    }

    override fun toLocalizedString(provider: JsStringProvider): String {
        val resolvedString = original.toLocalizedString(provider)
        return resolvedString.personalizeGender(hebrewGender)
    }
}
